import { useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { MessageSquareWarning } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { useMusic } from "@/lib/music/MusicProvider";

const CATS = [["bug", "Bug"], ["idea", "Idea"], ["other", "Other"]];

export const FeedbackButton = () => {
  const mus = useMusic();
  const musicOn = !!(mus?.current || mus?.sprint);
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const [cat, setCat] = useState("bug");
  const [msg, setMsg] = useState("");
  const send = async () => {
    try { await api.post("/feedback", { category: cat, message: msg.trim(), page: loc.pathname }); toast.success("Thanks! Your feedback reached the LoreRight team."); setMsg(""); setOpen(false); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <>
      <button onClick={() => setOpen(true)} className={`fixed right-6 z-40 flex ${musicOn ? "bottom-6 lg:bottom-32" : "bottom-6"} items-center gap-2 rounded-full border border-[#8B5CF6]/50 bg-[#13171F]/95 px-4 py-2 text-xs text-[#C4B5FD] shadow-lg backdrop-blur-md transition-transform hover:-translate-y-0.5`} data-testid="beta-feedback-button">
        <MessageSquareWarning className="h-4 w-4" />Send feedback
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="beta-feedback-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl">Send feedback</DialogTitle><DialogDescription>Tell us what broke or what you'd love. We'll see the page you're on: {loc.pathname}</DialogDescription></DialogHeader>
          <div className="flex gap-2">{CATS.map(([k, l]) => <Button key={k} size="sm" variant={cat === k ? "default" : "outline"} onClick={() => setCat(k)} data-testid={`feedback-cat-${k}`}>{l}</Button>)}</div>
          <Textarea value={msg} onChange={(e) => setMsg(e.target.value)} rows={5} placeholder="What happened, or what would help?" data-testid="feedback-message" />
          <DialogFooter><Button onClick={send} disabled={msg.trim().length < 3} data-testid="feedback-send">Send feedback</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
